export const ACCOUNT_TEMPLATE = '账户名称：\n账号：\n开户行：';
export const INVOICE_TEMPLATE =
  '开票公司名称：\n地址及电话：\n纳税人识别号：\n开户行：\n账号：';

export function getTemplateTextareaValue(
  value: string | null | undefined,
  template: string,
) {
  return value?.trim() ? value : template;
}

export function normalizeTemplateSubmitText(
  value: string | null | undefined,
  template: string,
) {
  const text = value?.replace(/\r\n/g, '\n') ?? '';
  if (!text.trim() || text.trim() === template.trim()) return null;
  return text;
}
